import React, { useEffect, useState } from 'react';
import jwt from 'jwt-decode';
import axios from 'axios';
import { userContext } from '../../context/userContext';
import { CMEAuthorizatioinAPIURL, CMEGetContactDetailsAPIURL, AuthorizationCredentials } from '../../config/config';

const defaultUser = {
  User: {
    name: '', acepid: '', city: '', state: '', country: '', isAdmin: false,
    id: '', firstName: '', lastName: '', formalName: '',
    acepExpirationDate: '', acepMemberStatus: 0, acepMemberType: '', acepMemberRate: '',
    sempaExpirationDate: '', sempaMemberStatus: 0, sempaMemberType: '', sempaMemberRate: '',
    ecmeCatalog: '', email2: '', address1: '', address2: '', phone: '',
    priceLevel: '', isValidUser: false, isOnAutoRenewal: false,
    loginUI_ExpiryDate: '', loginUI_Join: '', avatar: '', isABEMCertified: false
  }
};

// Detects an existing ACEP SSO session for the public CME requirements page,
// without redirecting to login when no session is found - the page stays
// public and the header simply falls back to Sign In/Join.
const PublicSSOProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [userObject, setUserObject] = useState(defaultUser);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    axios.get(CMEAuthorizatioinAPIURL, { withCredentials: true })
      .then((result: any) => {
        const tokenInfo: ITokenInfo = jwt(String(result.data));
        if (!tokenInfo?.sub) {
          setReady(true);
          return;
        }

        axios.get(CMEGetContactDetailsAPIURL + tokenInfo.sub, {
          headers: { Authorization: AuthorizationCredentials }
        })
          .then((res: any) => {
            const contact = res.data;
            setUserObject({
              User: {
                ...defaultUser.User,
                acepid: tokenInfo.sub,
                firstName: contact.firstName,
                lastName: contact.lastName,
                avatar: contact.avatar,
                loginUI_ExpiryDate: contact.loginUI_ExpiryDate,
                loginUI_Join: contact.loginUI_Join,
                acepMemberStatus: Number(contact.acepMemberStatus)
              }
            });
            setReady(true);
          })
          .catch(() => setReady(true));
      })
      .catch(() => setReady(true));
  }, []);

  if (!ready) return null;

  return <userContext.Provider value={userObject}>{children}</userContext.Provider>;
};

export default PublicSSOProvider;
